import classNames from 'classnames';
import * as React from 'react'
import { IBaseProperty, IUIPropertyDefinition, IWDDesignModeProps, PropertyPath, addToPath } from './common';
import { IContextData } from '../../hooks/useContextData';

export interface ISelectableItemUIProp {
    id: PropertyPath;
    value: IBaseProperty;
    definition: IUIPropertyDefinition<IBaseProperty>; //IUIPropertyDefinition<any?> ?
    customProps?: { [key: string]: any }
}
export interface ISelectableItemProps {
    designer: IWDDesignModeProps;
    props: ISelectableItemUIProp[];
    style?: React.CSSProperties;
    onChange?: (props: any) => void;
    contextData?: IContextData;
    className?: string;
    showAtRuntime?: boolean;
    elementId?: string;
    preventLosingFocusOnNextClick?: boolean;
    children?: React.ReactNode
}

export interface ISelectedItemRef {
    props: ISelectableItemUIProp[];
    onChange: (newProps: any) => void;
    elementId?: string
}

export function selectUIPropsAndAppendCustomProps(props: any, propDefs: any, customProps: any, ...keys: string[]) {
    const _selectedProps = selectUIProps(props, propDefs, ...keys)
    return _selectedProps.map(sp => {
        sp.customProps = customProps
        return sp
    })
}
export function selectUIProps(props: any, propDefs: any, ...keys: string[]): ISelectableItemUIProp[] {
    let results: ISelectableItemUIProp[] = [];
    let subKey = '';
    for (let key of keys) {
        if (key.indexOf('.') > 0) {
            let [newKey, ...rest] = key.split('.');
            key = newKey;
            subKey = rest.join('.');
        }
        if (propDefs[key]) {
            let propDef = propDefs[key];
            if (subKey) {
                propDef = propDefs[key][subKey];
            }
            let x: ISelectableItemUIProp = { value: props[key] || {}, definition: propDef, id: key };
            results.push(x);
        } else {
            continue;
        }

    }
    return results;
}

export function selectUIPropsForMobileTempaltes(props: any, propDef: any, index: number, customProps: any, ...keys: string[]) {
    if (index != undefined) {
        const _childUIProps = props?.fields?.[index]?.props?.uiProps || {}
        const _selectedProps = selectUIPropsAndAppendCustomProps(_childUIProps, propDef, customProps, ...keys)
        const updated = _selectedProps.map(sp => {
            const id = addToPath(['fields'], index, 'props', 'uiProps', sp.id as string)
            sp.id = id
            return sp
        })
        return updated
    }
    else return selectUIPropsAndAppendCustomProps(props, propDef, customProps, ...keys)
}

export interface ISelectableItemInstanceProps {
    triggerSelect?: () => void
}

export const SelectableItem: React.ForwardRefExoticComponent<React.RefAttributes<ISelectableItemInstanceProps> & ISelectableItemProps> = React.forwardRef((props, ref) => {
    let r = React.useRef<ISelectedItemRef>({ props: [], onChange: props.onChange, elementId: props.elementId });
    const selectableRef = React.useRef(null)


    let onSelect = props?.designer?.onSelect;

    React.useImperativeHandle(ref, () => ({
        triggerSelect: triggerSelect
    }))

    function triggerSelect() {
        onSelect?.(r, props.props, props.contextData, props.elementId)
    }

    if (!props.designer) {
        if (props.showAtRuntime) {
            return <div className={props.className || ''} style={props.style} >
                {props.children}
            </div>;
        }
        return <>{props.children}</>
    }

    r.current.props = props.props;

    let selected = r === props.designer.selectedItem;

    let highlight = props.designer.selectedPanel == 'properties'
    if (selected) highlight = false
    else if (!selected && props.designer.selectedItem) highlight = false

    return <div
        ref={selectableRef}
        style={{ ...props.style || {} }}
        onClick={(e) => {

            e.stopPropagation();

            if (props.preventLosingFocusOnNextClick) {
                !selected && onSelect?.(r, props.props, props.contextData, props.elementId);
            } else {
                onSelect?.(selected ? null : r, props.props, props.contextData, props.elementId);
            }

        }}
        className={classNames('wd-selectable-item', props.className || '',
            {
                'selected': selected,
                'highlight': highlight && props.designer.mode == 'preview'
            }
        )}

        id={props.elementId}
    >
        {props.children}
    </div>
})